import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { SgoModuloService } from '../services/sgo-modulo.service';


@Injectable({
  providedIn: 'root'
})
export class SgoModuloResolver implements Resolve<boolean> {

  constructor(private service: SgoModuloService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}